//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { scene: null, words: [], card: null } },
  created () {
    this.$ajax.get(this.$api.cpCardDetail + '?id=' + this.$route.query.id).then(r => {
      this.scene = r.scene; this.words = r.words || []; this.card = r.card
    })
  },
  methods: {
    share () {
      this.$ajax.post(this.$api.cpCardShare, { id: this.$route.query.id }).then(() => {
        this.$toast && this.$toast('已记录分享')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/context-puzzle/card.vue